import React from "react";
import { Card } from "./ui/card";
import { Users } from "lucide-react";
import { useQuery } from "@tanstack/react-query";
import { getUserCount } from "@/api/users";
import clsx from "clsx";

export const RegisteredUsersBanner: React.FC = () => {
  const { data } = useQuery({
    queryKey: ["user-count"],
    queryFn: async () => {
      return await getUserCount();
    },
  });

  const userCount = data?.count ?? 0;

  const formatNumber = (num: number) => {
    return num.toLocaleString();
  };

  return (
    <div className="w-full flex justify-center">
      <Card
        className={clsx(
          "w-full max-w-[1208px] bg-[#2963ea] border-0 shadow-lg shadow-black/20 relative overflow-hidden rounded-none lg:rounded-lg",
        )}
      >
        {/* Mobile Layout */}
        <div className="md:hidden px-4 py-1 min-h-[40px] flex items-center justify-center w-full">
          <div className="flex items-center justify-center gap-2">
            {userCount > 0 && (
              <>
                <div className="flex items-center justify-center w-6 h-6 bg-primary-foreground/20 rounded-full">
                  <Users className="w-3 h-3 text-primary-foreground" />
                </div>
                <span className="text-lg font-bold text-primary-foreground">
                  {formatNumber(userCount)}
                </span>
                <span className="text-sm text-primary-foreground/90 font-medium">
                  Registered Users
                </span>
                <span className="text-sm font-semibold text-primary-foreground">
                  Join the Herd!
                </span>
                <div className="flex items-center space-x-1 text-white/80 text-xs">
                  <div className="w-1.5 h-1.5 bg-green-400 rounded-full animate-pulse"></div>
                  <span>Live</span>
                </div>
              </>
            )}
          </div>
        </div>

        {/* Desktop Layout */}
        <div className="hidden md:flex items-center justify-between py-1 container">
          <div className="flex items-center gap-4 lg:gap-6">
            <div className="flex items-center justify-center w-12 h-12 lg:w-14 lg:h-14 bg-primary-foreground/20 rounded-full">
              <Users className="w-6 h-6 lg:w-7 lg:h-7 text-primary-foreground" />
            </div>
            <div>
              {userCount > 0 && (
                <div className="flex items-center gap-2 lg:gap-3">
                  <span
                    className={`text-3xl lg:text-4xl font-bold text-primary-foreground transition-all duration-500`}
                  >
                    {formatNumber(userCount)}
                  </span>
                  <div className="hidden lg:block">
                    <p className="text-lg xl:text-xl text-primary-foreground/90 font-medium">
                      Registered Users
                    </p>
                  </div>
                </div>
              )}
              <div className="block lg:hidden">
                <p className="text-base text-primary-foreground/90 font-medium">
                  Registered Users
                </p>
              </div>
            </div>
          </div>

          <div className="text-right">
            <p className="text-base lg:text-lg xl:text-xl font-semibold text-primary-foreground mb-1">
              Join the Herd!
            </p>
            <div className="flex items-center justify-end space-x-2 text-white/80 text-sm lg:text-base">
              <div className="w-2 h-2 bg-green-400 rounded-full animate-pulse"></div>
              <span>Live updates active</span>
            </div>
          </div>
        </div>

        <div className="absolute inset-0 bg-gradient-to-r from-transparent via-primary-foreground/5 to-transparent animate-pulse pointer-events-none" />
      </Card>
    </div>
  );
};
